<template>
  <div class="container">
    <div class="drawer-content">
      <div class="info-list">
        <div class="info-content">
          <!-- <h1 class="customer-title">
            {{ basicInfo.name ? basicInfo.name : customer.name }}
          </h1> -->
          <div class="list-bar-wrap">
            <div
              :class="[
                item.isChecked ? 'list-bar-item-checked' : 'list-bar-item',
              ]"
              v-for="item in listBar"
              @click="changeListBar(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="info">
            <div class="basic-purview">
              <div
                class="basic-info-wrap"
                v-if="isShowInfo"
              >
                <div class="title-wrap">
                  <h3>基础信息</h3>
                  <div
                    style="color: #858585; cursor: pointer"
                    @click="$refs.EditCustomerDetailDrawer.openDrawer(customer)"
                  >
                    编辑
                  </div>
                </div>
                <div class="basic-info">
                  <div class="basic-info-left">
                    <CustomerBasicInfoRow
                      field="法人代表"
                      :value="customer.legalRep"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="网址"
                      :value="customer.web"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="电话"
                      :value="customer.phone"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="邮箱"
                      :value="customer.email"
                      :type="'string'"
                    />

                    <CustomerBasicInfoRow
                      field="所属省份"
                      :value="customer.province"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="所属城市"
                      :value="customer.city"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="所属区县"
                      :value="customer.dist"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="信用代码"
                      :value="customer.creditCode"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="公司类型"
                      :value="customer.companyType"
                      :type="'string'"
                    />
                  </div>
                  <div class="basic-info-right">
                    <CustomerBasicInfoRow
                      field="公司简称"
                      :value="customer.abbr"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="参保人数"
                      :value="customer.socialSecurityCount"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="注册资本"
                      :value="customer.regisCapi"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="实缴资本"
                      :value="customer.paidCapi"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="所属行业"
                      :value="customer.industry"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="注册日期"
                      :value="customer.regisDate"
                      :type="'date'"
                    />
                    <CustomerBasicInfoRow
                      field="核准日期"
                      :value="customer.provedDate"
                      :type="'date'"
                    />
                    <CustomerBasicInfoRow
                      field="注册地址"
                      :value="customer.regisLoc"
                      :type="'string'"
                    />
                    <CustomerBasicInfoRow
                      field="经营范围"
                      :value="customer.scope"
                      :type="'string'"
                    />
                  </div>
                </div>
              </div>
              <div
                class="purview-info"
                v-if="isShowPurview"
              >
                <div class="title-wrap">
                  <h3>权限与状态</h3>
                  <div
                    style="color: #858585; cursor: pointer"
                    @click="
                      $refs.EditCustomerPurviewDrawer.openDrawer(customer)
                    "
                  >
                    编辑
                  </div>
                </div>
                <div class="basic-info">
                  <CustomerBasicInfoRow
                    field="所属部门"
                    :value="customer.department"
                    :type="'object'"
                  />
                  <CustomerBasicInfoRow
                    field="开发人员"
                    :value="customer.devSales"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="维护人员"
                    :value="customer.maintainSales"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="回款人员"
                    :value="customer.paymentSales"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="销售可见"
                    :value="customer.salesVisibleMember"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="技术可见"
                    :value="customer.techVisibleMember"
                    :type="'array'"
                  />
                  <CustomerBasicInfoRow
                    field="评分"
                    :value="customer.rating"
                    :type="'string'"
                  />
                  <CustomerBasicInfoRow
                    field="状态"
                    :value="customer.status"
                    :type="'status'"
                  />
                  <CustomerBasicInfoRow
                    field="允许开发"
                    :value="customer.allowDev"
                    :type="'dev'"
                  />
                  <!-- <CustomerBasicInfoRow
                  field="纳入销售统计"
                  :value="customer.name"
                /> -->
                </div>
              </div>
            </div>
            <div class="table-info"></div>
          </div>
        </div>
        <div class="list-wrap">
          <!-- <div class="task-list-wrap list-box">
            <div class="task-list list">
              <TaskPage ref="TaskPage" />
              <router-view />
            </div>
          </div>
          <div class="salesPlan-list-wrap list-box">
            <div class="salesPlan-list list">
              <SalesPlanPage ref="SalesPlanPage" />
              <router-view />
            </div>
          </div> -->
          <div
            class="receive-list-wrap list-box"
            v-if="isShowReceiveList"
          >
            <div class="receive-list list">
              <Receive ref="Receive" />
              <router-view />
            </div>
          </div>
          <div
            class="customerDevelop-list-wrap list-box"
            v-if="isShowCustomerDevelopList"
          >
            <div class="customerDevelop-list list">
              <CustomerDevelopPage ref="CustomerDevelopPage" />
              <router-view />
            </div>
          </div>
          <div
            class="sales-list-wrap list-box"
            v-if="isShowSalesList"
          >
            <div class="sales-list list">
              <Sales ref="Sales" />
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditCustomerDetailDrawer ref="EditCustomerDetailDrawer" />
    <EditCustomerPurviewDrawer ref="EditCustomerPurviewDrawer" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapState } from "vuex";
import TankRentalTabPane from "../TankRental/TankRentalTabPane";
import SalesRecordTabPane from "../SalesRecord/SalesRecordTabPane";
import SalesTabPane from "../Sales/SalesTabPane";
import CustomerBasicInfoRow from "@/components/CustomerBasicInfoRow.vue";
import EditCustomerDetailDrawer from "./EditCustomerDetailDrawer";
import EditCustomerPurviewDrawer from "./EditCustomerPurviewDrawer";
import TaskPage from "../../../TaskPage/index";
import SalesPlanPage from "../../../SalesPlanPage/index";
import CustomerDevelopPage from "../../../CustomerDevelopPage/index";
import Receive from "../../../ReceivePage/index";
import Sales from "../../../SalesPage/index";
import Setting from "../Setting";
import { arrayIntersection } from "@/utils";
import Comment from "@/components/layout/Comment.vue";

export default {
  name: "CustomerInfo",
  components: {
    TankRentalTabPane,
    SalesRecordTabPane,
    SalesTabPane,
    Setting,
    CustomerBasicInfoRow,
    EditCustomerDetailDrawer,
    EditCustomerPurviewDrawer,
    TaskPage,
    SalesPlanPage,
    CustomerDevelopPage,
    Receive,
    Sales,
    Comment,
  },
  data() {
    return {
      tabName: "basics",
      drawerOpened: false,
      mouseOverField: undefined,
      editedField: undefined,
      createdTime: "",
      tagsList: [
        {
          value: "搅拌站",
          label: "搅拌站",
        },
        {
          value: "管桩",
          label: "管桩",
        },
        {
          value: "构件",
          label: "构件",
        },
        {
          value: "管道",
          label: "管道",
        },
        {
          value: "水泥制品",
          label: "水泥制品",
        },
        {
          value: "中铁",
          label: "中铁",
        },
        {
          value: "中建",
          label: "中建",
        },
        {
          value: "中交",
          label: "中交",
        },
      ],
      basicInfo: {
        name: undefined,
        abbr: undefined,
        // 技术可见人
        techVisibleMember: undefined,
        // 销售可见人
        salesVisibleMember: undefined,
        // 部门
        department: undefined,
        // 开发人员
        devSales: undefined,
        // 维护人员
        maintainSales: undefined,
        // 回款人员
        paymentSales: undefined,
        includeInStat: {
          SO: true,
        },
        // 标签列表
        tags: [],
      },
      listBar: [
        {
          value: "basic",
          name: "基础信息",
          isChecked: true,
        },
        {
          value: "role",
          name: "权限",
          isChecked: true,
        },
        {
          value: "receive",
          name: "回款记录",
          isChecked: false,
        },
        {
          value: "customerDevelop",
          name: "客户开发",
          isChecked: false,
        },
        {
          value: "sales",
          name: "销售项目",
          isChecked: false,
        },
        // {
        //   value: "task",
        //   name: "任务",
        //   isChecked: false,
        // },
        // {
        //   value: "salesPlan",
        //   name: "销售计划",
        //   isChecked: false,
        // },
      ],
      isShowInfo: true,
      isShowPurview: true,
      isShowReceiveList: false,
      isShowCustomerDevelopList: false,
      isShowSalesList: false,
    };
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      updateCustomer: "customer/updateCustomerAction",
      deleteCustomer: "customer/deleteCustomerAction",
      saveCustomer: "customer/saveCustomerAction",
    }),
    deleSuccess() {
      this.drawerOpened = false;
    },
    changeListBar(e) {
      e.isChecked = !e.isChecked;
      switch (e.value) {
        case "basic":
          this.isShowInfo = !this.isShowInfo;
          break;
        case "role":
          this.isShowPurview = !this.isShowPurview;
          break;
        case "receive":
          this.isShowReceiveList = !this.isShowReceiveList;
          break;
        case "customerDevelop":
          this.isShowCustomerDevelopList = !this.isShowCustomerDevelopList;
          break;
        case "sales":
          this.isShowSalesList = !this.isShowSalesList;
          break;
        default:
          break;
      }
    },
    editField(field) {
      // 接收传进来对应编辑项
      this.editedField = field;
      // 根据不同内容进行编辑
      switch (field) {
        case "name":
          this.basicInfo.name = this.customer.name;
          this.$nextTick(() => {
            this.$refs.editInfoInput.focus();
          });
          break;
        case "abbr":
          this.basicInfo.abbr = this.customer.abbr;
          this.$nextTick(() => {
            this.$refs.editInfoInput.focus();
          });
          break;
        case "department":
          this.basicInfo.department =
            this.customer.department && this.customer.department._id;
          break;
        case "devSales":
          this.basicInfo.devSales =
            this.customer.devSales && this.customer.devSales.map((x) => x._id);
          break;
        case "maintainSales":
          this.basicInfo.maintainSales =
            this.customer.maintainSales &&
            this.customer.maintainSales.map((x) => x._id);
          break;
        case "paymentSales":
          this.basicInfo.paymentSales =
            this.customer.paymentSales &&
            this.customer.paymentSales.map((x) => x._id);
          break;
        case "techVisibleMember":
          this.basicInfo.techVisibleMember =
            this.customer.techVisibleMember &&
            this.customer.techVisibleMember.map((x) => x._id);
          break;
        case "salesVisibleMember":
          this.basicInfo.salesVisibleMember =
            this.customer.salesVisibleMember &&
            this.customer.salesVisibleMember.map((x) => x._id);
          break;
        case "tags":
          this.basicInfo.tags = this.customer.tags;
          break;
        default:
          break;
      }
    },
    async saveField(field) {
      this.editedField = null;
      let updateContent = {};
      updateContent[field] = this.basicInfo[field];
      switch (field) {
        case "name":
          if (this.basicInfo.name === this.customer.name) return;
          this.basicInfo.name = updateContent.name;
          break;
        case "department":
          if (this.basicInfo.department === this.customer.department) return;
          if (this.basicInfo.department === 0)
            updateContent["department"] = null;
          updateContent[field] = this.basicInfo.department;
          break;
        case "includeInStat":
          if (
            this.basicInfo.includeInStat.SO === this.customer.includeInStat.SO
          )
            return;
          break;
        case "abbr":
          if (this.basicInfo.abbr === this.customer.abbr) return;
          this.basicInfo.abbr = updateContent.abbr;
          break;
        case "techVisibleMember":
          if (
            this.basicInfo.techVisibleMember ===
            this.customer.techVisibleMember.map((x) => x._id)
          )
            return;
          break;
        case "salesVisibleMember":
          if (
            this.basicInfo.salesVisibleMember ===
            this.customer.salesVisibleMember.map((x) => x._id)
          )
            return;
          break;
        case "devSales":
          if (
            this.basicInfo.devSales === this.customer.devSales.map((x) => x._id)
          )
            return;
          break;
        case "maintainSales":
          if (
            this.basicInfo.maintainSales ===
            this.customer.maintainSales.map((x) => x._id)
          )
            return;
          break;
        case "paymentSales":
          if (
            this.basicInfo.paymentSales ===
            this.customer.paymentSales.map((x) => x._id)
          )
            return;
          break;
        default:
          break;
      }

      try {
        const so = await this.updateCustomer({
          id: this.customer._id,
          data: updateContent,
        });
        this.$nextTick(() => {});
        this.saveBasicInfo(so);
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
    saveBasicInfo(customer) {
      if (customer) {
        // 部门
        this.basicInfo.department =
          customer.department && customer.department._id;
        // 销售统计
        this.basicInfo.includeInStat.SO =
          customer.includeInStat && customer.includeInStat.SO;
        // 客户简称
        this.basicInfo.abbr = customer.abbr;
        // 技术可见人
        this.basicInfo.techVisibleMember =
          customer.techVisibleMember &&
          customer.techVisibleMember.map((x) => x._id);
        // 销售可见人
        this.basicInfo.salesVisibleMember =
          customer.salesVisibleMember &&
          customer.salesVisibleMember.map((x) => x._id);
        // 开发人员
        this.basicInfo.devSales =
          customer.devSales && customer.devSales.map((x) => x._id);
        // 维护人员
        this.basicInfo.maintainSales =
          customer.maintainSales && customer.maintainSales.map((x) => x._id);
        // 回款人员
        this.basicInfo.paymentSales =
          customer.paymentSales && customer.paymentSales.map((x) => x._id);
        // 标签
        this.basicInfo.tags = customer.tags;
      }
      this.basicInfo.department =
        this.customer.department && this.customer.department._id;
      this.basicInfo.includeInStat.SO =
        this.customer.includeInStat && this.customer.includeInStat.SO;
      this.basicInfo.abbr = this.customer.abbr;
      this.basicInfo.tags = this.customer.tags;
      this.basicInfo.techVisibleMember =
        this.customer.techVisibleMember &&
        this.customer.techVisibleMember.map((x) => x._id);
      this.basicInfo.salesVisibleMember =
        this.customer.salesVisibleMember &&
        this.customer.salesVisibleMember.map((x) => x._id);
      this.basicInfo.devSales =
        this.customer.devSales && this.customer.devSales.map((x) => x._id);
      this.basicInfo.maintainSales =
        this.customer.maintainSales &&
        this.customer.maintainSales.map((x) => x._id);
      this.basicInfo.paymentSales =
        this.customer.paymentSales &&
        this.customer.paymentSales.map((x) => x._id);
    },
  },
  mounted() {},
  async created() {
    this.saveBasicInfo(this.customer);
  },
  computed: {
    ...mapGetters({
      getDepartmentByType: "department/getDepartmentByType",
      getTreeSelectDepartment: "department/getTreeSelectDepartment",
      getCustomerById: "customer/getCustomerById",
    }),
    ...mapState({
      user: (state) => state.auth.currentUser,
      userList: (state) => state.user.userList,
      departmentList: (state) => state.department.departmentList,
      detailCustomersId: (state) => state.customer.detailCustomersId,
      customer: (state) => state.customer.selectCustomer,
      customerId: (state) => state.customer.detailCustomersId,
    }),
  },
  watch: {
    tabName(value) {
      switch (value) {
        case "tankRental":
          this.$nextTick(() => {
            this.$refs.TaskPage.loadTask({ customer: customer });
          });
          break;
        case "salesRecord":
          this.$nextTick(() => {
            this.$refs.SalesRecordTabPane.loadMaterial();
          });
          break;
        case "sales":
          this.$nextTick(() => {
            this.$refs.SalesTabPane.loadSales();
          });
          break;
      }
    },
    customer() {
      this.createdTime = dayjs(this.customer.createdAt).format("YYYY-MM-DD");
      return this.createdTime;
    },
    $route: {
      handler(val, old) {
        if (this.isShowReceiveList) {
          this.$nextTick(() => {
            this.$refs.Receive.loadReceive();
          });
        }
        if (this.isShowCustomerDevelopList) {
          this.$nextTick(() => {
            this.$refs.Receive.loadCustomerDevelop();
          });
        }
        if (this.isShowSalesList) {
          this.$nextTick(() => {
            this.$refs.Receive.loadSales();
          });
        }
      },
    },
  },
};
</script>

<style scoped lang="stylus">
.drawer-content
  display flex
  padding 0

.container
  width 100%
  height 100%

.list-bar-wrap
  display flex

  .list-bar-item
    border 1px solid #dcdee2
    padding 0 15px
    font-size 16px
    height 40px
    line-height 38px
    color #515a6e
    transition all 0.2s ease-in-out
    cursor pointer

  .list-bar-item:hover
    color #2d8cf0

  .list-bar-item-checked
    border 1px solid #2d8cf0
    padding 0 15px
    font-size 16px
    height 40px
    line-height 38px
    color #2d8cf0
    cursor pointer

.info-content
  width 80%
  min-width 1200px
  padding 16px

.basic-purview
  display flex
  align-items flex-start

.title-wrap
  display flex
  justify-content space-between
  margin-bottom 15px

.basic-info-wrap
  width 60%
  min-width 700px
  border 1px solid #c9c9c9
  padding 10px

  .basic-info
    display flex

    .basic-info-right
      margin-left 20px

.basic-info-left, .basic-info-right
  width 50%

.purview-info
  border 1px solid #c9c9c9
  width 30%
  min-width 350px
  padding 10px
  margin-left 30px

.info-list
  overflow-y scroll
  padding-bottom 50px
  height 830px

.list-wrap
  overflow auto

  .list-box
    width 1250px
    margin-left 15px
    margin-bottom 15px

    .list
      width 1200px
      border 1px solid #c9c9c9
</style>